import React, { useEffect, useRef } from "react";
import { endpoints } from "Core/defaultValues";

const EVIRView = () => {
  const iframeRef = useRef(null);

  // Get the token
  const idToken = localStorage.getItem("IdToken");
  const refreshToken = localStorage.getItem("RefreshToken");
  const username = localStorage.getItem("username");
  const preferencesCompany = JSON.parse(localStorage.getItem("preferencesCompany") ?? "{}");
  const evir_web_app_url = preferencesCompany?.data[0]?.entityId ? `${endpoints.EVIR_WEB_APP_URL}&pxAccountId=${preferencesCompany?.data[0]?.entityId}` : endpoints.EVIR_WEB_APP_URL;

  useEffect(() => {
    const sendToken = () => {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          { idToken, refreshToken, username },
          evir_web_app_url
        );
      }
    };

    // Send the token once the iframe loads
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.onload = sendToken;
    }
  }, [idToken]); // Re-run if the token changes

  return (
    <div style={{ height: "95vh" }}>
      <iframe
        ref={iframeRef}
        id="evir-portal"
        title="EVIR Portal"
        width="100%"
        height="100%"
        src={evir_web_app_url}
      ></iframe>
    </div>
  );
};

export default EVIRView;
